import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";

export * from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";

export default WidgetModule;
